<h2>What else can you tell us?</h2>
<p><span class="asteriskColoring">*</span> indicates a required field</p>

<!-- <div id="preNextErrorMsgContainer">
    <ng-container *ngIf="problemQuestions.length > 0 && isErrorPresentOnPage">
        <p class="preNextErrorMsgText preNextErrorLabel">Please provide reponses to all asterisk'd marked questions.</p>
    </ng-container>
</div> -->

<ng-container *ngIf="problemQuestions.length > 0">
    <div class="problemQuestionsContainer">
        <h3>{{questionHeading}}</h3>

        <ng-container *ngFor="let problemQuestion of problemQuestions; trackBy:trackByFn">
            <div [class.vehicleFirstRow]="isVehicleQuestion && problemQuestion.questionNumber < 3 && !isMobile.any()">
                <div class="problemQuestionAnswer" [class.hidden]="problemQuestion.questionViewable === false">

                    <p class="questionLabelContainer" *ngIf="problemQuestion.questionType !== 'confirmation'">
                        {{problemQuestion.question}}
                        <span class="questionRequired" [class.required-field]="problemQuestion.isRequired"></span>

                        <ng-container *ngIf="problemQuestion.tooltip">
                            <span class="questionTooltip">
                                <span class="tooltipArrow"></span>
                                <i class="fas fa-question-circle"></i>
                                <span class="tooltipText">{{problemQuestion.tooltip}}</span>
                            </span>
                        </ng-container>

                        <!-- <ng-container *ngIf="!problemQuestion.isRequired">
                            <span class="optionalTag">(optional)</span>
                        </ng-container> -->
                    </p>

                    <ng-container *ngIf="problemQuestion.questionType === 'select'">
                        <select [(ngModel)]="problemQuestion.answer" class="answerSelectBox" (change)="updateAnswer()">
                            <option [value]="null" selected disabled>Please select</option>
                            <option *ngFor="let opt of problemQuestion.selectOptions" [value]="opt">{{opt}}</option>
                        </select>

                        <p *ngIf="problemQuestion.shouldDisplayNotFilledError" class="preNextErrorLabel">{{problemQuestion.errorMsgText}}</p>
                    </ng-container>

                    <ng-container *ngIf="problemQuestion.questionType === 'check'">
                        <div class="checkBoxContainer">
                            <ng-container *ngFor="let opt of problemQuestion.checkOptionAnswers">
                                <label>
                                    <input
                                    [value]="opt.option" type="checkbox" class="checkSelector"
                                    [(ngModel)]="opt.answer" (change)="updateAnswer()">

                                    <span>{{opt.option}}</span>
                                </label>
                            </ng-container>
                        </div>

                        <p *ngIf="problemQuestion.shouldDisplayNotFilledError" class="preNextErrorLabel">{{problemQuestion.errorMsgText}}</p>
                    </ng-container>

                    <ng-container *ngIf="problemQuestion.questionType === 'radio'">
                        <div class="radioContainer" [class.horizontalRadioOptions]="checkShouldAlignHorizontal(problemQuestion)">

                            <ng-container *ngFor="let opt of problemQuestion.radioOptions">
                                <div class="radioSelectBox">
                                    <label for="{{getRadioName(problemQuestion)}}">
                                        <input
                                            [value]="opt" type="radio" class="radioSelector" name="{{getRadioName(problemQuestion)}}"
                                            [(ngModel)]="problemQuestion.answer" (change)="updateAnswer()">

                                        {{opt}}
                                    </label>
                                </div>

                                <ng-container *ngIf="opt === 'Other' && problemQuestion.answer === opt">
                                    <div class="otherTextInput">
                                        <textarea 
                                            [(ngModel)]="problemQuestion.radioOtherOptionEntry" 
                                            class="answerTextboxEntry radioOtherEntryInput" 
                                            (input)="updateAnswer()"
                                            [class.preNextErrorInput]="problemQuestion.shouldDisplayNotFilledError">
                                            {{problemQuestion.radioOtherOptionEntry}}
                                        </textarea>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="problemQuestion.shouldDisplayNotFilledError">
                                <ng-container *ngIf="problemQuestion.answer === 'Other' && problemQuestion.radioOtherOptionEntry?.length === 0; else normalRadioError">
                                    <p class="preNextErrorLabel">Please enter a response.</p>
                                </ng-container>

                                <ng-template #normalRadioError>
                                    <p class="preNextErrorLabel">{{problemQuestion.errorMsgText}}</p>
                                </ng-template>
                            </ng-container>


                            <ng-container *ngIf="shouldDisplayConditionalResponse(problemQuestion)">
                                <span class="conditionalResponse">

                                    <ng-container *ngIf="problemQuestion.answer === 'No'">
                                        <span [class.redResponseText]="shouldDisplayTextAsRed(problemQuestion)">{{problemQuestion.conditionalNoMsg}}</span>
                                    </ng-container>

                                    <ng-container *ngIf="problemQuestion.answer === 'Yes'">
                                        <span>{{problemQuestion.conditionalYesMsg}}</span>
                                    </ng-container>
                                </span>
                            </ng-container>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="problemQuestion.questionType === 'text'">
                        <ng-container *ngIf="problemQuestion.question === 'Age'">
                            <!-- <textarea [(ngModel)]="problemQuestion.answer" class="answerTextboxEntry" maxlength="3" (input)="updateAnswer()">
                                {{problemQuestion.answer}}
                            </textarea> -->
                            <input type="number" class="answerTextboxEntry ageInput" [(ngModel)]="problemQuestion.answer" maxlength="3" (input)="updateAnswer()" /> years
                        </ng-container>

                        <ng-container *ngIf="problemQuestion.question !== 'Age'">
                            <textarea 
                                [(ngModel)]="problemQuestion.answer" class="answerTextboxEntry" 
                                [class.preNextErrorInput]="problemQuestion.shouldDisplayNotFilledError" 
                                maxlength="50" (input)="updateAnswer()">
                                
                                {{problemQuestion.answer}}
                            </textarea>
                        </ng-container>

                        <p *ngIf="problemQuestion.shouldDisplayNotFilledError" class="preNextErrorLabel">{{problemQuestion.errorMsgText}}</p>

                    </ng-container>

                    <ng-container *ngIf="problemQuestion.questionType === 'confirmation'">
                        <div class="checkBoxContainer">
                            <label>
                                <input type="checkbox" class="checkSelector" [(ngModel)]="problemQuestion.confirmationAnswer" (change)="updateAnswer()">

                                {{problemQuestion.confirmationTypeMsg}}
                                <span class="questionRequired" [class.required-field]="problemQuestion.isRequired"></span>
                            </label>
                        </div>

                        <p *ngIf="problemQuestion.shouldDisplayNotFilledError" class="preNextErrorLabel">{{problemQuestion.errorMsgText}}</p>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>

<input id="fileSelectionInput" type="file" accept=".png, .jpg, .jpeg" multiple hidden />

<h3 id="headerAttachPhoto">
    Attach a photo
</h3>
<p class="photoLimitText">You can add up to 5 photos.</p>

<ng-container *ngIf="!isMobile.any()">
    <div class="attachPhotoContainer" id="attachPhotoContainer"
        (drop)="itemDropHandler($event)" (dragover)="itemDragOverHandler($event)"
        (dragleave)="itemDragEndHandler()">

        <div class="dragAndDropNonSelected">
            <!-- <i class="fas fa-upload"></i> -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M122.6 155.1L240 51.63V368c0 8.844 7.156 16 16 16s16-7.156 16-16V51.63l117.4 104.3C392.4 158.7 396.2 160 400 160c4.406 0 8.812-1.812 11.97-5.375c5.875-6.594 5.25-16.72-1.344-22.58l-144-128c-6.062-5.406-15.19-5.406-21.25 0l-144 128C94.78 137.9 94.16 148 100 154.6S116.1 161.8 122.6 155.1zM448 320h-112c-8.836 0-16 7.162-16 16c0 8.836 7.164 16 16 16H448c17.67 0 32 14.33 32 32v64c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32v-64c0-17.67 14.33-32 32-32h112C184.8 352 192 344.8 192 336C192 327.2 184.8 320 176 320H64c-35.35 0-64 28.65-64 64v64c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64v-64C512 348.7 483.3 320 448 320zM440 416c0-13.25-10.75-24-24-24s-24 10.75-24 24s10.75 24 24 24S440 429.3 440 416z"/></svg>
            <p>Drag and Drop file(s) here</p>
            <p>or</p>
            <button class="browseFilesBtn" (click)="openFileSelectionDialog()">Browse files</button>
            <!-- <p class="microcopy">Maximum file size: 4MB</p> -->
            <p class="microcopy">Accepted file types: jpg, jpeg, png</p>
        </div>
    </div>
    <p class="uploadErrorMsg" id="photoUploadErrorMessage"></p>
</ng-container>

<ng-container *ngIf="photoList.length > 0 && !isMobile.any()">
    <div class="desktopSelectedPhotosContainer">
        <div class="photoRow1">

            <ng-container *ngFor="let photoFile of getPhotoList(1)">
                <div class="photoRowItemWidth">
                    <div class="photoItemContainer">
                        <div class="photoItem addedPhoto">
                            <button (click)="handlePhotoRemoval(photoFile.hash)">X</button>
                            <img src="{{photoFile.dataURL}}">
                        </div>

                        <ng-container *ngIf="photoFile.imageStatus === 'uploading'">
                            <div class="photoItemDetails">
                                <div class="photoName">{{photoFile.file.name}}</div>
                                <div class="progress-bar">
                                    <span class="bar">
                                      <span class="progress" id="{{photoFile.hash}}"></span>
                                    </span>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="photoFile.imageStatus !== 'uploading'">
                            <div class="photoItemDetails">
                                <div class="photoName">{{photoFile.file.name}}</div>

                                <ng-container *ngIf="photoFile.imageStatus === 'rejected'">
                                    <div class="rejectImageUpload">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        <!-- <span> Upload unsuccessful</span> -->
                                        <span> {{getUploadErrorMessage(photoFile)}}</span>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="photoFile.imageStatus === 'success'">
                                    <div class="photoSize">{{getFileSize(photoFile.file.size)}}</div>
                                    <!-- <div>
                                        <div class="photoSize">{{getFileSize(photoFile.file.size)}}</div>
                                    </div> -->
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="photoRow2">
            <div *ngFor="let photoFile of getPhotoList(2)" class="photoRowItemWidth">
                <div class="photoItemContainer">
                    <div class="photoItem addedPhoto">
                        <button (click)="handlePhotoRemoval(photoFile.hash)">X</button>
                        <img src="{{photoFile.dataURL}}">
                    </div>

                    <ng-container *ngIf="photoFile.imageStatus === 'uploading'">
                        <div class="photoItemDetails">
                            <div class="photoName">{{photoFile.file.name}}</div>
                            <div class="progress-bar">
                                <span class="bar">
                                  <span class="progress" id="{{photoFile.hash}}"></span>
                                </span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="photoFile.imageStatus !== 'uploading'">
                        <div class="photoItemDetails">
                            <div class="photoName">{{photoFile.file.name}}</div>

                            <ng-container *ngIf="photoFile.imageStatus === 'rejected'">
                                <div class="rejectImageUpload">
                                    <i class="fas fa-exclamation-triangle"></i>
                                    <!-- <span> Upload unsuccessful</span> -->
                                    <span> {{getUploadErrorMessage(photoFile)}}</span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="photoFile.imageStatus === 'success'">
                                <div class="photoSize">{{getFileSize(photoFile.file.size)}}</div>
                                <!-- <div>
                                    <div class="photoSize">{{getFileSize(photoFile.file.size)}}</div>
                                </div> -->
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isMobile.any()">
    <div class="attachPhotoContainerMobile" id="attachPhotoContainerMobile">
        <ng-container *ngIf="photoList.length === 0">
            <div class="cameraControl" (click)="openFileSelectionDialog()">
                <!-- <i class="fas fa-camera"></i> -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M144 288C144 226.1 194.1 176 256 176C317.9 176 368 226.1 368 288C368 349.9 317.9 400 256 400C194.1 400 144 349.9 144 288zM256 208C211.8 208 176 243.8 176 288C176 332.2 211.8 368 256 368C300.2 368 336 332.2 336 288C336 243.8 300.2 208 256 208zM362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82H362.9zM64 128C46.33 128 32 142.3 32 160V416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V160C480 142.3 465.7 128 448 128H350.3L332.6 74.94C330.4 68.41 324.3 64 317.4 64H194.6C187.7 64 181.6 68.41 179.4 74.94L161.7 128H64z"/>
                </svg>
            </div>
        </ng-container>

        <ng-container *ngIf="photoList.length > 0">
            <div class="selectedPhotosContainer">

                <ng-container *ngFor="let photoFile of photoList">
                    <div class="photoItem addedPhoto" [class.mobilePhotoErr]="photoFile.imageStatus === 'rejected'">
                        <button (click)="handlePhotoRemoval(photoFile.hash)">X</button>
                        <img src="{{photoFile.dataURL}}">
                    </div>
                </ng-container>

                <!-- <ng-container *ngIf="photoList.length !== MAX_NUM_PHOTOS_ALLOWED"> -->
                    <div class="photoItem addPhoto" (click)="openFileSelectionDialog()">
                        <div class="icon"><i class="fas fa-plus"></i></div>
                    </div>
                <!-- </ng-container> -->
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="isMobile.any()">
    <p class="uploadErrorMsg" id="photoUploadErrorMessage"></p>
    <!-- <p class="microcopy">Maximum file size: 4MB</p>
    <p class="microcopy">Accepted file types: jpg, jpeg, png</p> -->
</ng-container>

<h3 class="headerTextEntry">Add a description</h3>
<div class="textEntryContainer">
    <p class="textEntryInfo" [class.required-field]="problemQuestions.length == 0">
        Include any details that could help us find and fix the problem.
    </p>

    <p *ngIf="isErrorPresentOnPage && problemQuestions.length == 0" class="preNextErrorLabel">Please add a problem description.</p>

    <ng-container *ngIf="problemQuestions.length > 0">
        <textarea #textbox [(ngModel)]="detailsTextEntry" class="textEntryTextbox" [maxlength]="MAX_NUM_CHARACTERS_ALLOWED" (input)="updateEntry()">{{detailsTextEntry}}</textarea>
    </ng-container>

    <ng-container *ngIf="problemQuestions.length == 0">
        <textarea #textbox 
            [(ngModel)]="detailsTextEntry" class="textEntryTextbox" 
            [maxlength]="MAX_NUM_CHARACTERS_ALLOWED" (input)="updateEntry()" 
            required [class.preNextErrorInput]="isErrorPresentOnPage">{{detailsTextEntry}}</textarea>
    </ng-container>

    <p class="microcopy">{{remainingCharactersAvailable}} characters remaining</p>
</div>
